// React
import { memo, useContext, useState } from "react";

// MUI
import {
	Box,
	Chip,
	CircularProgress,
	Grid,
	IconButton,
	Tooltip,
} from "@mui/material";

// Libraries
import moment from "moment-timezone";

// ICONS
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import DeleteIcon from "@mui/icons-material/Delete";
import { Context } from "./Context";

const PaycodeAssingn = ({ paycodeAssign }) => {
	return (
		<Tooltip
			title={
				<>
					{paycodeAssign.map((p) => (
						<Grid
							container
							spacing={2}
							key={p.id}
							sx={{ width: "180px" }}
						>
							<Grid item xs={12}>
								{`${p?.paycode.name}: ${p?.amount}`}:
								{`Start: ${p.start}`}
							</Grid>
						</Grid>
					))}
				</>
			}
			placement="top"
		>
			<span>
				<Chip color="primary" variant="outlined" />
			</span>
		</Tooltip>
	);
};

const ShiftCell = memo(({ shift, pay_period_end }) => {
	// eslint-disable-next-line
	const [loading, setLoading] = useState(false);

	const { setShiftId, setOpenEditShift, setOpenDeleteShift } =
		useContext(Context);

	const permisionDelete = JSON.parse(
		localStorage.getItem("permissions")
	)?.find((permision) => permision === "scheduler.DeleteShift");
	const permisionEdit = JSON.parse(localStorage.getItem("permissions"))?.find(
		(permision) => permision === "scheduler.PatchShift"
	);

	const props = {
		onDelete: permisionDelete
			? () => {
					setShiftId(shift.shift_id);
					setOpenDeleteShift(true);
			  }
			: undefined,
		deleteIcon: permisionDelete ? (
			loading ? (
				<IconButton disabled sx={{ p: 0.5 }}>
					<CircularProgress size={13.5} color="inherit" />
				</IconButton>
			) : (
				<DeleteIcon />
			)
		) : undefined,
		onClick: permisionEdit
			? () => {
					setShiftId(shift.shift_id);
					setOpenEditShift(true);
			  }
			: undefined,
	};

	return (
		<Tooltip
			title={
				<>
					{shift?.segments.map((segment) => (
						<Grid
							container
							spacing={2}
							key={segment.segment_id}
							sx={{ width: "180px" }}
						>
							<Grid item xs={6}>
								{`${segment?.type}`}:
							</Grid>

							<Grid item xs={6}>
								{`${moment(
									segment?.start_ts,
									"YYYY-MM-DDTHH:mm:ssZ"
								).format("HH:mm")} - ${moment(
									segment?.end_ts,
									"YYYY-MM-DDTHH:mm:ssZ"
								).format("HH:mm")}`}
							</Grid>
						</Grid>
					))}
				</>
			}
			placement="top"
		>
			<Chip
				icon={<WorkHistoryIcon sx={{ p: 0.25 }} />}
				label={`${moment
					.utc(
						`${shift?.date} ${shift?.start_ts}`,
						"YYYY-MM-DD HH:mm:ss"
					)
					.local()
					.format("HH:mm")} - ${moment
					.utc(
						`${shift?.date} ${shift?.end_ts}`,
						"YYYY-MM-DD HH:mm:ss"
					)
					.local()
					.format("HH:mm")}`}
				{...props}
				disabled={moment(pay_period_end, "YYYY-MM-DD").isSameOrAfter(
					moment(shift?.date, "YYYY-MM-DD")
				)}
			/>
		</Tooltip>
	);
});

const RenderCell = ({ params, setCell }) => {
	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				gap: 1,
				//alignContent: "center",
				//padding: "10px",
			}}
			onClick={() => {
				console.log("params", params.value);
			}}
			onContextMenu={(event) => {
				event.preventDefault();
				setCell({
					column: params,
					row: params?.id,
				});
			}}
			id={`${params?.field}-cell-${params?.id}`}
			/* sx={{
				width: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				alignContent: "center",
				padding: "10px",
			}} */
		>
			{/* {`cantidad de turnos: ${params?.value?.shifts.length}`} */}

			{params?.value?.shifts
				?.slice()
				.sort((a, b) => a.start_ts.localeCompare(b.start_ts))
				.map((shift) => (
					<ShiftCell
						key={shift.shift_id}
						shift={shift}
						pay_period_end={params?.row?.pay_period_end}
					/>
				))}

			{params?.value?.paycodeAssign.length > 0 ? (
				<PaycodeAssingn paycodeAssign={params?.value?.paycodeAssign} />
			) : null}
		</Box>
	);
};

export { RenderCell };
